// src/components/store/sections/faqs/FaqV25BentohelpEmeraldMint.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV25BentohelpEmeraldMint(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={25}
      archKey="bento_help"
      archLabel="Bento Help Matrix"
      palName="EmeraldMint"
      grad="from-emerald-500 via-teal-500 to-emerald-700"
      lightBg="bg-emerald-50"
      textCol="text-emerald-700"
      borderCol="border-emerald-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#10b981"
      {...props}
    />
  );
}
